// Centralized helpers to persist Dealer Onboard form in sessionStorage (browser-only)
// Safely guards for non-browser environments

const hasSession = () =>
  typeof window !== "undefined" &&
  typeof window.sessionStorage !== "undefined";

export const makeDealerOnboardStorageKey = (dealerId, prospectId) => {
  const id = dealerId || prospectId || "new";
  return `actyv_dealer_onboard_state_${id}`;
};

export const loadPersistedDealerOnboard = (storageKey) => {
  try {
    if (!hasSession()) return null;
    const raw = window.sessionStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (_) {
    return null;
  }
};

export const savePersistedDealerOnboard = (storageKey, data) => {
  try {
    if (!hasSession()) return;
    window.sessionStorage.setItem(storageKey, JSON.stringify(data || {}));
  } catch (_) {
    // ignore
  }
};

export const clearPersistedDealerOnboard = (storageKey) => {
  try {
    if (!hasSession()) return;
    window.sessionStorage.removeItem(storageKey);
  } catch (_) {
    // ignore
  }
};


